var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.WI=require("moment");module.exports=$CLJS.WI;